//ALL Label Of Dropdown

export const Dispatch_From_City="Dispatch From City"
export const Dispatch_From_Branch="Dispatch From Branch"
export const Transfer_By_Vehicle="Transfer By Vehicle"
export const Receiving_City="Receiving City"
export const Receiving_Branch="Receiving Branch"
export const Select_Vehicle="Select Vehicle"
export const Select_Challan="Select Challan"
export const BranchReceiv_Consignment_Type="Consignment Type"
export const Transfer_From_City="Transfer From City"

// Receive Item List Lebels
export const Received_Transfer_From_City="Transfer From City"
export const Received_Transfer_From_Branch="Transfer From Branch"
export const Received_To_City="Received To City"
export const Received_To_Branch="Received To Branch"
export const Transfer_Type="Transfer Type"
export const ReceivedItem_Payment_Type="Payment Type"
export const ReceivedItem_Consignment_Type="Consignment Type"
export const ReceivedItem_vehicleNo="Vehicle No"
export const ReceivedItem_ChallanNo="Challan No"


// Receive Labeles 
export const Receive_Dispatch_From_City="Dispatch From City"
export const Receive_Dispatch_From_Branch="Dispatch From Branch"
export const Receive_Receiving_City="Receiving City"
export const Receieve_Receiving_Branch="Receiving Branch"
export const Receive_Select_Vehicle="Select Vehicle"
export const Receieve_Select_Challan="Select Challan"
export const Receive_Consignment_Type="Consignment Type"

// Receive Received Item List Labeles 
export const Receive_Received_Dispatch_From_City="Dispatch from City"
export const Received_Dispatch_From_Branch="Dispatch from Branch"
export const Receive_Received_To_City="Received To City"
export const Receive_Received_To_Branch="Received to Branch"
export const Receive_ReceivedItem_Payment_Type="Payment Type"
export const Receive_ReceivedItem_Consignment_Type="Consignment Type"
export const Receive_ReceivedItem_vehicleNo="Vehicle No"
export const Receive_ReceivedItem_ChallanNo="Challan No"